import { ComponentType } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { isAuthenticated, isInitialized, role } from '../../redux/profile/selectors'
import PrivateRoute, { IProps } from './PrivateRoute'

export interface OwnProps {
  path: string
  exact?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- accepts any route component
  component: ComponentType<any>
}
const selector = createStructuredSelector({
  isAuthenticated,
  isInitialized,
  role,
})
const connector = connect(selector)
/* eslint-disable @typescript-eslint/no-empty-object-type */
export type PropsFromRedux = InferConnectedProps<typeof connector, {}>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, PrivateRoute)
